import request from '../utils/request.js'


//注册账号
export function postRegister(data) {
  return request({
    url: '/app_client/client/register',
    method: 'post',
    data: data
  })
}


//发送邮箱code
export function putVerify(data) {
  return request({
    url: '/app_client/client/verify',
    method: 'put',
    data: data
  })
}


//登录账号
export function postLogin(data) {
  return request({
    url: '/app_client/client/login',
    method: 'post',
    data: data
  })
}


//重置密码发送邮箱code
export function postReset(data) {
  return request({
    url: '/app_client/client/sendEmail',
    method: 'post',
    data: data
  })
}

//重置密码
export function postResetPwd(data) {
  return request({
    url: '/app_client/client/retPwd',
    method: 'post',
    data: data
  })
}

//个人中心新增激活码账号
export function getKeyGener(params) {
  return request({
    url: '/app_client/client/keyGener',
    method: 'get',
    params,
  })
}

//个人中心获取激活码账号数据
export function getAllKey(params) {
  return request({
    url: '/app_client/userInfo/allKey',
    method: 'get',
    params,
  })
}


//个人中心获取新激活码账号数据
export function getNewAllKey(params) {
  return request({
    url: '/app_client/clientKey/getKeyList',
    method: 'get',
    params,
  })
}

//个人中心获取字符分配记录
export function getCharacters(params) {
  return request({
    url: '/app_client/characters/list',
    method: 'post',
    params,
  })
}

//个人中心获取字符分配记录
export function getUsedChar(params) {
  return request({
    url: '/app_client/userInfo/usedChar',
    method: 'get',
    params,
  })
}


//获取计数器
export function postWorkOrderList(data) {
  return request({
    url: '/app_client/work_order/list?token=' + data.token + '&startDate=' + data.startDate + '&pageNum=' + data
      .pageNum + '&pageSize=' + data.pageSize + '&workOrderNumber=' + data.workOrderNumber + '&workOrderType=' +
      data.workOrderType,
    method: 'post',
    data: data
  })
}

//计数器查询
export function getWorkOrder(data) {
  return request({
    url: '/app_client/work_order/byOrderTypeinfo?token=' + data.token + '&workOrderNumber=' + data.workOrderNumber +
      '&clientUserld=' + data.clientUserld + '&workOrderType=' + data.workOrderType,
    method: 'post',
    data: data,
  })
}

//个人中心激活码账号搜索
export function getByKeyValue(data) {
  return request({
    url: '/app_client/userInfo/byKeyValue?token=' + data.token + '&keyValue=' + data.keyValue,
    method: 'get',
    data: data,
  })
}

//查看账号数据
export function getWorkOrderInfo(data) {
  return request({
    url: '/app_client/work_order/infoWAByWorkOrderId?workOrderId=' + data.workOrderId + '&pageNum=' + data
      .pageNum + '&pageSize=' + data.pageSize + '&userNickname=' + data.userNickname,
    method: 'post',
    data: data,
  })
}

//计数器创建工单
export function postAddOrder(data) {
  return request({
    url: '/app_client/work_order/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
  })
}


//查询聊天记录列表
export function getChatRecordList(params) {
  return request({
    url: '/app_client/userInfo/allKey',
    method: 'get',
    params,
  })
}


//查询聊天用户
export function getChatByRecipeName(data) {
  return request({
    url: '/app_client/accountFriendChat/getChatByKeyId?token=' + data.token + '&key=' + data.key +
      '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize + '&loginName=' + data.loginName,
    method: 'post',
    data: data,
  })
}


//查询支付记录
export function postOrderList(params) {
  return request({
    url: '/app_client/order/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params,
  })
}

//查询用户聊天记录
export function getChatRecord(params) {
  return request({
    url: '/app_client/chatRecord/chatRecordList',
    method: 'get',
    params,
  })
}

//根据工单类型查询
export function postByOrderType(data) {
  return request({
    url: '/app_client/work_order/byOrderTypeinfo?token=' + data.token + '&client_user_id=' + data.client_user_id +
      '&workordertype=' + data.workordertype,
    method: 'post',
    data: data,
  })
}


//根据工单id删除
export function postRemoveWorkOrder(data) {
  return request({
    url: '/app_client/work_order/remove?token=' + data.token + '&workOrderIds=' + data.workOrderIds,
    method: 'post',
    data: data,
  })
}


//根据工单id编辑
export function postWorkOrderEdit(data) {
  return request({
    url: '/app_client/work_order/edit',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
  })
}

//根据工单号释放离线账号
export function postDeleteWorkOrder(data) {
  return request({
    url: '/app_client/work_order/deleteWorkOrders?token=' + data.token + '&workOrderNumbers=' + data
      .workOrderNumbers,
    method: 'post',
    data: data,
  })
}


//关闭工单
export function postCloseWork(data) {
  return request({
    url: '/app_client/work_order/closeWork?token=' + data.token + '&workOrderNumbers=' + data.workOrderNumbers,
    method: 'post',
    data: data,
  })
}


//删除工单下的账号
export function postDeleteAccount(data) {
  return request({
    url: '/app_client/work_order/deleteWAccount?token=' + data.token + '&workOrderAccountIds=' + data
      .workOrderAccountIds,
    method: 'post',
    data: data,
  })
}

//根据账号名称查询账号
export function postSearcNickName(data) {
  return request({
    url: '/app_client/work_order/searchWOAccountByUserNickname?userNickname=' + data.userNickname,
    method: 'post',
    data: data,
  })
}


//根据keyid删除激活码账号
export function postDeleteKeyId(data) {
  return request({
    url: '/app_client/userInfo/deleteKeyByKeyId?token=' + data.token + '&KeyId=' + data.KeyId,
    method: 'post',
    data: data,
  })
}


//根据keyvalue查询聊天发送者
export function postFindByKey(data) {
  return request({
    url: '/app_client/accountFriendChat/findByKey?token=' + data.token + '&key=' + data.key + '&pageNum=' + data
      .pageNum + '&pageSize=' + data.pageSize,
    method: 'post',
    data: data,
  })
}

//根据工单id与工单账号id查询粉丝
export function postFansByWaid(data) {
  return request({
    url: '/app_client/work_order/fansInfoByWAId?workOrderId=' + data.workOrderId + '&workOrderAccountId=' + data
      .workOrderAccountId + '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize + '&userNickname=' + data
        .userNickname,
    method: 'post',
    data: data,
  })
}


//查看历史账号数据
export function getHistoryRecord(params) {
  return request({
    url: '/app_client/work_order/historyRecord',
    method: 'get',
    params,
  })
}

//粉丝根据昵称搜索
export function getSearchByNickName(params) {
  return request({
    url: '/app_client/work_order/searchByNickName',
    method: 'get',
    params,
  })
}


//根据工单id查询工单信息
export function postListWorkOrderId(data) {
  return request({
    url: '/app_client/work_order/shareInfo?workOrderId=' + data.workOrderId,
    method: 'post',
    data: data,
  })
}



//分配字符
export function postAllCateChar(data) {
  return request({
    url: '/app_client/clientKey/allocateCharacters',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
  })
}

//更新用户字符余量数据
export function postGetUserInfo(data) {
  return request({
    url: '/app_client/userInfo/searchRemainingCharacters?token=' + data.token,
    method: 'post',
    data: data,
  })
}


//生成订单
export function postOrderPay(data) {
  return request({
    url: '/app_client/order/pay?token=' + data.token + '&packageId=' + data.packageId + '&packageNum=' + data
      .packageNum,
    method: 'post',
    data: data,
  })
}


//查询有未支付
export function postOrderQuery(data) {
  return request({
    url: '/app_client/order/query?token=' + data.token + '&transactionOrderId=' + data.transactionOrderId,
    method: 'post',
    data: data,
  })
}


//客户中心查询列表
export function postChatRecord(data) {
  return request({
    url: '/app_client/chatRecord/customerMsg?token=' + data.token + '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize,
    method: 'post',
    data: data,
  })
}
// 个人中心查询
export function getUserInfo(data) {
  return request({
    url: '/app_client/userInfo/findkeyAccuntInfo?token=' + data.token,
    method: 'post',
    data: data,
  });
}

//客户中心编辑
export function postEditCMsg(data) {
  return request({
    url: '/app_client/accountFriendChat/editCustomerMsg',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
  })
}

//客户编辑删除
export function postDeleteCMsg(data) {
  return request({
    url: '/app_client/accountFriendChat/deleteCustomterMsg?id=' + data.id,
    method: 'post',
    data: data,
  })
}


//客户中心查询
export function postSearchCMsg(data) {
  return request({
    url: '/app_client/accountFriendChat/serarchCustomerMsg',
    method: 'post',
    data: data,
  })
}



//粉丝根据昵称搜索
export function getVersionNumber(params) {
  return request({
    url: '/download/latest.yml',
    method: 'get',
    params,
  })
}



















// 获取商品列表
export const getDevicePage = (data) => {
  return request({
    url: '/app_client/client/login',
    method: 'post',
    data
  })
}

export function getCsList(params) {
  return request({
    url: '/captchaImage',
    method: 'get',
    params,
    //判断是否加入token
    // headers: {
    //   isToken: true
    // },
  })
}

// get1请求
export function getList(params) {
  return request({
    url: '/shoe/userInfo/list',
    method: 'get',
    params,
    //判断是否加入token
    // headers: {
    //   isToken: true
    // },
  })
}

// get2请求
export function getList2(id) {
  return request({
    url: '/shoe/douYin/' + id,
    method: 'get'
  })
}

//post请求
export function postList(data) {
  return request({
    url: '/app_client/client/login',
    method: 'post',
    data: data
  })
}

//put请求
export function putList(data) {
  return request({
    url: '/shoe/douyin',
    method: 'put',
    data: data
  })
}

//delete请求
export function deleteList(id) {
  return request({
    url: '/shoe/douyin/' + id,
    method: 'delete'
  })
}


//个人中心
export function findkeyAccuntInfo(data) {
  return request({
    url: '/app_client/userInfo/findkeyAccuntInfo?token=' + data.token,
    method: 'post',
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js